import { toArray } from '@m1/geo-utils';
import { GUIDE_STYLES } from '@m1/ol-map';
import OlMap from '@m1/ol-map';
import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import { pointerMove } from 'ol/events/condition';
import Feature from 'ol/Feature';
import { LineString, MultiPoint } from 'ol/geom';
import { Select } from 'ol/interaction';
import { Vector as VectorLayer } from 'ol/layer';
import { fromLonLat } from 'ol/proj';
import { Vector as VectorSource } from 'ol/source';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import actions from '@/actions';
import { createFenceFeatures } from '@/utils/FenceUtil';

const GuideMissions = () => {
  const dispatch = useDispatch();
  const missions = useSelector((state) => state.missions);
  const addedLayer = useRef({});
  const map = OlMap.getMap();

  useUpdateEffect(() => {
    const currMissionIds = Object.keys(addedLayer.current);
    const nextMissionIds = missions.map(({ id }) => id);

    // Guide Mission 추가
    if (currMissionIds.length < nextMissionIds.length) {
      const willBeAddedMissions = missions.filter(({ id }) => !currMissionIds.includes(id));

      willBeAddedMissions.forEach((mission) => {
        const positions = mission.path
          //! useEditorPath hook 동시 참고
          // '/survey/end' 경로점은 제외하지 않음
          .filter(({ id }) => !id.endsWith('/takeoff/end'))
          .filter(({ id }) => !id.endsWith('/land/end'))
          .filter(({ id }) => !id.endsWith('/rtl/end'))
          .map(({ position }) => fromLonLat(toArray(position)));

        const path = new Feature({ geometry: new LineString(positions) });
        const points = new Feature(new MultiPoint(positions));
        const fences = createFenceFeatures(mission.fences);

        const source = new VectorSource({ features: [path, points, ...fences] });
        const layer = new VectorLayer({
          source,
          declutter: true,
          style: (feature) => {
            const geometry = feature.getGeometry();

            switch (geometry.getType()) {
              // 경로 스타일
              case 'LineString':
                return GUIDE_STYLES.PATH;

              // 경로점 스타일
              case 'MultiPoint':
                return geometry.getCoordinates().map((coord, index) => {
                  return GUIDE_STYLES.POINT(coord, index);
                });

              // Fence 스타일
              case 'Circle':
              case 'Polygon':
                return GUIDE_STYLES.FENCE;

              default:
                break;
            }
          },
        });
        map.addLayer(layer);
        addedLayer.current[mission.id] = layer;

        // Mouse over 시 강조
        const handleHover = new Select({
          condition: pointerMove,
          layers: [layer],
        });
        handleHover.on('select', (e) => {
          if (e.selected.length) {
            dispatch(actions.callout.setText(mission.name));
          } else {
            dispatch(actions.callout.setText(null));
          }
        });
        map.addInteraction(handleHover);
      });
    }
    // Guide Mission 제거
    else {
      const willBeRemovedIds = currMissionIds.filter((id) => !nextMissionIds.includes(id));

      willBeRemovedIds.forEach((id) => {
        map.removeLayer(addedLayer.current[id]);
        delete addedLayer.current[id];
      });
    }
  }, [missions]);

  return null;
};

export default GuideMissions;
